<template>
  <app-overlay-feature :map="map" :value="drawing" :feature="trackedFeature"></app-overlay-feature>
</template>

<script>
import DrawInteraction from 'ol/interaction/draw'
import OLObservable from 'ol/observable'
import Feature from 'ol/feature'

import { LayerDraw } from '../layers'
import style, { styleError, nullStyle } from '../style'
import isOutOfExtent from '../out-of-extent'

import AppOverlayFeature from './overlay-feature'

/**
 * Componente para dibujar features
 */
export default {
  props: ['map', 'mode', 'active', 'drawing'],

  components: {
    AppOverlayFeature
  },

  data() {
    return {
      DrawController: null,
      listenerFeatureChange: null,
      listenerOutOfBounds: null,
      trackedFeature: null
    }
  },

  methods: {
    createInteractionDraw() {
      let featureChanges = null

      const geometryFunction = this.mode == 'Circle'
        ? DrawInteraction.createBox()
        : null

      this.DrawController = new DrawInteraction({
        type: this.mode,
        geometryFunction,
        source: LayerDraw.getSource(),
        style: nullStyle,
        finishCondition: () =>{
          return this.finishCondition(featureChanges)
        }
      })

      this.DrawController.setActive(this.drawing)
      this.map.addInteraction(this.DrawController)

      this.DrawController.on('drawstart', ({feature}) => {
        this.listenerFeatureChange = feature.getGeometry().on('change', event => {
          const geometry = event.target
          featureChanges = new Feature({ geometry })

          this.trackedFeature = featureChanges
        })

        this.listenerOutOfBounds = this.map.on('pointermove', event => {
          if(!featureChanges) {
            return
          }

          const outOfExtent = isOutOfExtent(featureChanges, this.map.getView().getProjection())
          feature.setStyle(outOfExtent ? styleError : style)
        })

        LayerDraw.getSource().clear()
      })

      this.DrawController.on('drawend', event => {
        const feature = event.feature

        if(!this.finishCondition(feature)) {
          //console.log('Finish Condition clear')
          return setTimeout(() => LayerDraw.getSource().clear(), 0)
        }

        this.$emit('drawend', feature.clone())
        
        OLObservable.unByKey(this.listenerOutOfBounds)
        OLObservable.unByKey(this.listenerFeatureChange)

        this.listenerFeatureChange = null
        this.listenerOutOfBounds = null
        this.trackedFeature = null
      })
    },

    finishCondition(feature) {
      const isOut = isOutOfExtent(feature, this.map.getView().getProjection())
      //console.log('FinishCondition', isOut)
      if(isOut) {
        this.DrawController.setActive(false)
        this.$store.dispatch('setError', 'La geometría no puede estar fuera del ámbito')
        this.DrawController.setActive(true)
      }

      return !isOut
    }

  },


  watch: {
    mode() {
      OLObservable.unByKey(this.listenerOutOfBounds)
      OLObservable.unByKey(this.listenerFeatureChange)

      this.listenerFeatureChange = null
      this.listenerOutOfBounds = null

      this.map.removeInteraction(this.DrawController)

      if(this.mode) {
        this.createInteractionDraw()
        // this.DrawController.setActive(true)
      }
    },

    active(active) {
      if(!this.DrawController) {
        this.createInteractionDraw()
      }

      LayerDraw.getSource().clear()
      LayerDraw.setMap(active ? this.map : null)
    },

    drawing(isDrawActive) {
      LayerDraw.getSource().clear()
      LayerDraw.changed()

      this.DrawController.setActive(isDrawActive)
    }
  }
}
</script>


// WEBPACK FOOTER //
// draw-feature.vue?240753d2